import { render, staticRenderFns } from "./ContratacaoDetalhesCard.vue?vue&type=template&id=5e619998"
import script from "./ContratacaoDetalhesCard.vue?vue&type=script&lang=js"
export * from "./ContratacaoDetalhesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports